import { useEffect, useRef, useCallback } from "react"
import { useScroll } from "framer-motion"
/**
 * Whenever the user scrolls to the bottom, load more posts.
 * @param loadMorePosts A function that loads more posts.
 */
export function useInfiniteScroll(
  contentRef: React.MutableRefObject<null | HTMLDivElement>,
  loadMorePosts: () => void,
  threshold = 0.8,
  cooldownMs = 1000
) {
  const { scrollYProgress } = useScroll({ target: contentRef })
  const lastLoadTimeRef = useRef(0)

  const checkAndLoad = useCallback(() => {
    const now = Date.now()
    if (now - lastLoadTimeRef.current >= cooldownMs) {
      console.log("useInfiniteScroll loading more posts")
      loadMorePosts()
      lastLoadTimeRef.current = now
    }
  }, [loadMorePosts, cooldownMs])

  useEffect(() => {
    const unsubscribe = scrollYProgress.onChange((latest) => {
      if (latest > threshold) {
        checkAndLoad()
      }
    })

    return () => {
      unsubscribe()
    }
  }, [scrollYProgress, threshold, checkAndLoad])
}
